import type { Locale } from '../i18n/locale';

/** Intake page copy per locale (formal "usted" in Spanish; native B2B English). */
export const INTAKE = {
  'es-CO': {
    mark: 'Iniciar proyecto',
    title: 'Cuéntenos qué necesita comprar su empresa.',
    lead: 'Con su necesidad estructuramos el requerimiento, revisamos su viabilidad y preparamos el abastecimiento. No necesita proveedor, partida arancelaria ni plan logístico.',
    next: ['Revisamos y estructuramos el requerimiento.', 'Validamos viabilidad, requisitos para Colombia y alternativas de origen.', 'Le presentamos el camino propuesto antes de comprometer la compra.'],
    stepsLabel: 'Pasos de la solicitud',
    optional: 'opcional',
    fields: {
      need: { label: '¿Qué necesita comprar, reemplazar o abastecer?', hint: 'Producto, uso, cantidad aproximada y cualquier referencia que tenga. Puede ser incompleto.' },
      category: 'Categoría', select: 'Seleccione…', scope: 'Alcance', quantity: 'Cantidad aproximada', reference: 'Referencia, marca o proveedor actual',
      city: 'Ciudad de entrega en Colombia', date: { label: '¿Para cuándo lo necesita?', hint: 'La fecha se valida en la revisión del requerimiento.' },
      company: 'Empresa', name: 'Nombre', role: 'Cargo', email: 'Correo corporativo', phone: 'Teléfono o WhatsApp',
      consent: 'Autorizo a COLESCOMEX a usar estos datos para atender esta solicitud y contactarme sobre ella.',
    },
    summary: { need: 'Necesidad', context: 'Contexto', contact: 'Empresa y contacto', edit: 'Editar' },
    handoff: {
      mail: 'Su solicitud está estructurada. Al continuar se abrirá su correo con el resumen dirigido a nuestro equipo comercial.',
      send: 'Enviar al equipo comercial', subject: 'Solicitud de proyecto',
      pendingStrong: 'La recepción digital de solicitudes se está habilitando.',
      pending: 'Su requerimiento ya está estructurado: copie o descargue el resumen para compartirlo con nuestro equipo comercial.',
      copy: 'Copiar resumen', copied: 'Resumen copiado', download: 'Descargar resumen', file: 'colescomex-solicitud.txt',
      fine: 'No comprometemos precio, plazo ni viabilidad de importación antes de validar el requerimiento.',
    },
    nav: { back: 'Atrás', next: 'Continuar', review: 'Revisar solicitud' },
  },
  en: {
    mark: 'Start a project',
    title: 'Tell us what your company needs to purchase.',
    lead: 'From your need, we structure the requirement, review its feasibility and prepare sourcing. You do not need a supplier, a tariff classification or a logistics plan.',
    next: ['We review and structure the requirement.', 'We validate feasibility, requirements for Colombia and origin alternatives.', 'We present the proposed path before the purchase is committed.'],
    stepsLabel: 'Request steps',
    optional: 'optional',
    fields: {
      need: { label: 'What do you need to purchase, replace or supply?', hint: 'Product, use, approximate quantity and any reference you have. It can be incomplete.' },
      category: 'Category', select: 'Select…', scope: 'Scope', quantity: 'Approximate quantity', reference: 'Reference, brand or current supplier',
      city: 'Delivery city in Colombia', date: { label: 'When do you need it?', hint: 'The date is validated during the requirement review.' },
      company: 'Company', name: 'Name', role: 'Job title', email: 'Business email', phone: 'Phone or WhatsApp',
      consent: 'I authorize COLESCOMEX to use this information to handle this request and to contact me about it.',
    },
    summary: { need: 'Need', context: 'Context', contact: 'Company and contact', edit: 'Edit' },
    handoff: {
      mail: 'Your request is structured. Continuing opens your email with the summary addressed to our commercial team.',
      send: 'Send to the commercial team', subject: 'Project request',
      pendingStrong: 'Digital request intake is being enabled.',
      pending: 'Your requirement is already structured: copy or download the summary to share it with our commercial team.',
      copy: 'Copy summary', copied: 'Summary copied', download: 'Download summary', file: 'colescomex-request.txt',
      fine: 'We do not commit to price, timing or import feasibility before the requirement is validated.',
    },
    nav: { back: 'Back', next: 'Continue', review: 'Review request' },
  },
} as const satisfies Record<Locale, unknown>;
